<template>
  <div class="shift-header mb-4">
    <p class="mb-0 font-weight-medium">{{ getShiftName(shift) }}</p>
  </div>
</template>

<script>
export default {
  name: "ShiftHeader",
  props: {
    shift: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getShiftName(shift) {
      const translation = (this.$store.state.company?.shift_translations || []).find(
        (st) => {
          return st.shift_code === shift.code && st.language_code === this.$i18n.locale;
        }
      );
      return translation?.label || this.$t(shift.code) || shift.name || shift.code;
    },
  },
};
</script>

<style scoped>
.shift-header {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
  text-align: center;
}
</style>
